import { useEffect } from 'react';

type TerminalModule = {
  id?: string;
  state?: { studentWorkflowState?: string | null };
} | null | undefined;

type LeaveNavigation = {
  navigate: (screen: string, params?: { moduleId?: string; courseId?: string }) => void;
};

/**
 * A graded module opens the grade report. A submitted module returns to the
 * course list. The module page does not paint in either case.
 */
export function useLeaveTerminalModule({
  module,
  isLoading,
  courseId,
  navigation,
}: {
  module: TerminalModule;
  isLoading: boolean;
  courseId?: string;
  navigation: LeaveNavigation;
}): boolean {
  const state = module?.state?.studentWorkflowState;
  const leave = !isLoading && !!module && (state === 'graded' || state === 'submitted');

  useEffect(() => {
    if (!leave || !module) return;
    if (state === 'graded') {
      navigation.navigate('GradeScreen', { moduleId: module.id, courseId });
      return;
    }
    navigation.navigate('CourseScreen');
  }, [leave, module, state, courseId, navigation]);

  return leave;
}
